export default __webpack_public_path__ + "static/playing-black-2d5757dd71ec72dc2c7d8a97073b561d.gif";